import { GetUserProfileQuery, useGetUserProfileQuery } from '@websky/graphql';
import { currentUserFactory } from './utils';
import { useConfig } from '../context';

export const WEBSKY_CURRENT_USER = 'webskyCurrentUser';

export const useCurrentUser = (skip?: boolean) => {
	const currentUserInGlobalScope = useConfig()?.global?.currentUserInGlobalScope;
	const usePixel = useConfig()?.global?.usePixel;

	const shouldSkip = skip ?? !(currentUserInGlobalScope || usePixel);

	const onCompleted = (data: GetUserProfileQuery) => {
		if (!data?.CurrentUser) {
			return;
		}

		const userData = currentUserFactory(data.CurrentUser);

		const event = new CustomEvent(WEBSKY_CURRENT_USER, {
			detail: userData
		});

		window[WEBSKY_CURRENT_USER] = userData;

		document.dispatchEvent(event);
	};

	const { data, refetch, loading } = useGetUserProfileQuery({
		fetchPolicy: 'no-cache',
		skip: shouldSkip,
		onCompleted
	});

	const reinitialize = async () => {
		const data = await refetch();
		onCompleted(data?.data);
	};

	return {
		data,
		loading,
		reinitialize
	};
};
